/// <amd-module name="typeahead/core/OnFocusSuggester" />

import {ISuggesterConfig, SuggesterId, SuggestionsAggregator} from "typeahead/core/SuggestionsAggregator";

export class OnFocusSuggester extends SuggestionsAggregator {
    public getEssOnFocusPersonalizedSuggesterConfig(): ISuggesterConfig {
        return {
            isEnabled: true,
            rank: 2,
        };
    }

    public getCurrentLocationSuggesterConfig(): ISuggesterConfig {
        return {
            isEnabled: true,
            rank : 1,
        };
    }

    public getId(): SuggesterId {
        return SuggesterId.OnFocusSuggester;
    }
}
